module.exports = __webpack_public_path__ + "@/assets/img/logo-ipp.a6ab6929.svg";